import { render, staticRenderFns } from "./FixedThead.vue?vue&type=template&id=484dc6fe&"
import script from "./FixedThead.vue?vue&type=script&lang=js&"
export * from "./FixedThead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports